"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const sizes = {
  XL: {
    L: 256,
    M: 192,
    S: 96
  },
  L: {
    L: 128,
    M: 96,
    S: 48
  },
  M: {
    L: 96,
    M: 64,
    S: 32
  },
  S: {
    L: 40,
    M: 32,
    S: 20
  },
  XS: {
    L: 28,
    M: 28,
    S: 16
  }
};
const setApplication = (applyToDevice, size) => {
  switch (applyToDevice) {
    case 'desktop':
      return (0, _styledComponents.css)`
      @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        height: ${sizes[size || 'S'].M}px;
      }
      @media (min-width: ${_breakpoints.BREAKPOINTS.xl}px) {
        height: ${sizes[size || 'S'].L}px;
      }
      `;
    case 'mobile':
      return (0, _styledComponents.css)`
      @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        height: ${sizes[size || 'S'].S}px;
      }
      `;
    case 'both':
      return (0, _styledComponents.css)`
      height: ${sizes[size || 'S'].S}px;
      @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        height: ${sizes[size || 'S'].M}px;
      }
      @media (min-width: ${_breakpoints.BREAKPOINTS.xl}px) {
        height: ${sizes[size || 'S'].L}px;
      }
      `;
    default:
      return;
  }
};
const Block = _styledComponents.default.div`
  width: 100%;
  ${props => setApplication(props.applyToDevice, props.paddingSize)};
`;
exports.Block = Block;
//# sourceMappingURL=styles.js.map